import {
  Button,
  Col,
  Form,
  Image,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Space,
  Table,
  Upload,
  Alert,
  Card,
  Tag,
  Statistic,
  Tooltip,
} from "antd";
import { useEffect, useState } from "react";
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  SearchOutlined,
  GiftOutlined,
  EyeOutlined,
  DownloadOutlined,
  UploadOutlined,
  FileExcelOutlined,
  FilterOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { apiCall } from "../../API/RestApi";
import Search from "antd/es/input/Search";
import { useSelector } from "react-redux";
import { saveAs } from "file-saver";
import { exportPrize } from "./ExportPrize";
import * as XLSX from "xlsx-js-style";

function ListPrize() {
  const token = useSelector((state) => state.user.token);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [importLoading, setImportLoading] = useState(false);

  const [isModal, setIsModal] = useState(false);
  const [dataModal, setDataModal] = useState(null);

  const [isDetailModal, setIsDetailModal] = useState(false);
  const [detailData, setDetailData] = useState(null);

  const [search, setSearch] = useState("");
  const [filterStatus, setFilterStatus] = useState("true");
  const [filterStock, setFilterStock] = useState("");

  const [isAlert, setIsAlert] = useState(false);
  const [textAlert, setTextAlert] = useState("");

  const [imagePreview, setImagePreview] = useState(null);
  const [fileImage, setFileImage] = useState(null);

  const [remainingProbability, setRemainingProbability] = useState(100);
  const [maxProbability, setMaxProbability] = useState(100);

  const [page, setPage] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });

  const [form] = Form.useForm();

  useEffect(() => {
    getData();
    getRemainingProbability();
  }, [JSON.stringify(page), search, filterStatus, filterStock]);

  const getData = () => {
    setLoading(true);

    let url =
      "/prize?search=" +
      search +
      "&page=" +
      page.pagination.current +
      "&limit=" +
      page.pagination.pageSize;

    if (filterStatus !== "") {
      url += "&status=" + filterStatus;
    }

    if (filterStock !== "") {
      url += "&stock=" + filterStock;
    }

    apiCall({
      method: "GET",
      url,
      data: {
        headers: {
          Authorization: "Bearer " + token,
        },
      },
    })
      .then((res) => {
        if (res.status === 200) {
          setData(res.data.rows || []);
          setPage({
            ...page,
            pagination: {
              ...page.pagination,
              total: res.data.count || 0,
            },
          });
        }
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  };

  const getRemainingProbability = async (record = null) => {
    try {
      const res = await apiCall({
        method: "GET",
        url: "/probability/prize",
        data: {
          headers: {
            Authorization: "Bearer " + token,
          },
        },
      });
      if (res.status === 200) {
        const remaining = Number(res.data.remaining_probability || 0);
        const currentProbability = record ? Number(record.probability || 0) : 0;
        const max = remaining + currentProbability;

        setRemainingProbability(remaining);
        setMaxProbability(max);

        return max;
      }
    } catch (e) {
      console.log(e);
    }

    return 100;
  };

  const openModal = async (type, record = null) => {
    setDataModal(null);
    setImagePreview(null);
    setFileImage(null);
    form.resetFields();

    await getRemainingProbability(type === "edit" ? record : null);

    if (type === "edit") {
      setDataModal(record);
      setImagePreview(record.image);

      form.setFieldsValue({
        name: record.name,
        description: record.description,
        stock: record.stock,
        price: record.price,
        probability: record.probability,
        is_active: String(record.is_active),
      });
    } else {
      form.setFieldsValue({
        probability: 0,
        stock: 0,
        price: 0,
        is_active: "true",
      });
    }

    setIsModal(true);
  };

  const closeModal = () => {
    setIsModal(false);
    setDataModal(null);
    setImagePreview(null);
    setFileImage(null);
    form.resetFields();
  };

  const openDetail = (record) => {
    setDetailData(record);
    setIsDetailModal(true);
  };

  const modalDeleteData = (record) => {
    Modal.confirm({
      title: "NOTICE",
      content: `Anda ingin menghapus hadiah "${record.name}"?`,
      okText: "Hapus",
      cancelText: "Batal",
      onOk: () => postApi("DELETE", record),
    });
  };

  const postApi = (method, values) => {
    setLoading(true);

    let url = "/prize";

    if (method === "PUT") {
      url = "/prize/" + dataModal.prize_id;
    }

    if (method === "DELETE") {
      url = "/prize/" + values.prize_id;
    }

    apiCall({
      method,
      url,
      data: {
        data: values,
        headers: {
          Authorization: "Bearer " + token,
        },
      },
    })
      .then((res) => {
        setLoading(false);

        if (res.status === 200) {
          setIsAlert(true);
          setTextAlert(res.message || "Data berhasil disimpan");
          closeModal();
          getData();
          getRemainingProbability();
        } else {
          Modal.error({
            title: "Gagal",
            content: res.message,
          });
        }
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  };

  const onFinish = (values) => {
    if (Number(values.probability || 0) > Number(maxProbability)) {
      Modal.error({
        title: "Probability Melebihi Batas",
        content: `Maksimal probability saat ini adalah ${maxProbability}%`,
      });
      return;
    }

    const formData = new FormData();

    formData.append("name", values.name);
    formData.append("description", values.description || "");
    formData.append("stock", values.stock || 0);
    formData.append("price", values.price || 0);
    formData.append("probability", values.probability || 0);
    formData.append("is_active", values.is_active);

    if (fileImage) {
      formData.append("image", fileImage);
    }

    if (dataModal) {
      formData.append("OldImage", dataModal.image || "");
      postApi("PUT", formData);
    } else {
      postApi("POST", formData);
    }
  };

  const uploadImage = (info) => {
    setFileImage(info.file);

    const reader = new FileReader();
    reader.addEventListener("load", () => setImagePreview(reader.result));
    reader.readAsDataURL(info.file);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setPage({
      pagination,
      filters,
      ...sorter,
    });
  };

  const searchData = (value) => {
    setSearch(value);
    setPage({
      pagination: {
        current: 1,
        pageSize: 10,
      },
    });
  };

  const resetFilter = () => {
    setSearch("");
    setFilterStatus("true");
    setFilterStock("");
    setPage({
      pagination: {
        current: 1,
        pageSize: 10,
      },
    });
  };

  const downloadTemplate = () => {
    const ws = XLSX.utils.aoa_to_sheet([
      ["name", "description", "stock", "price", "probability", "is_active", "image"],
      ["Voucher Diskon 50%", "Hadiah voucher", 10, 50000, 20, "true", "https://image.com"],
    ]);

    ws["!cols"] = [
      { wch: 30 },
      { wch: 40 },
      { wch: 10 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 40 },
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Template");

    const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    saveAs(new Blob([buf]), "template-prize.xlsx");
  };

  const importExcel = async (file) => {
    setImportLoading(true);

    try {
      const buffer = await file.arrayBuffer();
      const workbook = XLSX.read(buffer, { type: "array" });

      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(sheet);

      if (json.length === 0) {
        Modal.error({
          title: "Import Gagal",
          content: "Data kosong",
        });
        setImportLoading(false);
        return false;
      }

      const totalProbability = json.reduce(
        (sum, item) => sum + Number(item.probability || 0),
        0
      );

      if (totalProbability > remainingProbability) {
        Modal.error({
          title: "Import Gagal",
          content: `Total probability ${totalProbability}% melebihi sisa ${remainingProbability}%`,
        });
        setImportLoading(false);
        return false;
      }

      const res = await apiCall({
        method: "POST",
        url: "/prize/import-excel",
        data: {
          data: { rows: json },
          headers: {
            Authorization: "Bearer " + token,
          },
        },
      });

      if (res.status === 200) {
        Modal.success({
          title: "Berhasil",
          content: "Import berhasil",
        });

        getData();
        getRemainingProbability();
      }
    } catch (err) {
      console.log(err);
      Modal.error({
        title: "Error",
        content: "File tidak valid",
      });
    }

    setImportLoading(false);
    return false;
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  const columns = [
    {
      title: "No",
      key: "no",
      width: 70,
      render: (text, record, index) =>
        (page.pagination.current - 1) * page.pagination.pageSize + index + 1,
    },
    {
      title: "Gambar",
      dataIndex: "image",
      key: "image",
      width: 110,
      render: (text) => (
        <Image
          width={70}
          height={70}
          src={text}
          style={{ objectFit: "cover", borderRadius: 12 }}
        />
      ),
    },
    {
      title: "Nama Hadiah",
      dataIndex: "name",
      key: "name",
      render: (text) => <b>{text}</b>,
    },
    {
      title: "Stock",
      dataIndex: "stock",
      key: "stock",
      width: 100,
      render: (text) => (
        <Tag color={Number(text) > 0 ? "green" : "red"}>{text}</Tag>
      ),
    },
    {
      title: "Harga",
      dataIndex: "price",
      key: "price",
      width: 120,
      render: (text) => Number(text || 0).toLocaleString("id-ID"),
    },
    {
      title: "Probability",
      dataIndex: "probability",
      key: "probability",
      width: 130,
      render: (text) => <Tag color="blue">{text}%</Tag>,
    },
    {
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      width: 110,
      render: (text) =>
        text === true || text === "true" ? (
          <Tag color="green">Aktif</Tag>
        ) : (
          <Tag color="red">Nonaktif</Tag>
        ),
    },
    {
      title: "Action",
      key: "action",
      width: 290,
      fixed: "right",
      render: (text, record) => (
        <Space>
          <Tooltip title="Lihat detail hadiah">
            <Button onClick={() => openDetail(record)} icon={<EyeOutlined />} />
          </Tooltip>

          <Tooltip title="Ubah data hadiah">
            <Button
              type="primary"
              onClick={() => openModal("edit", record)}
              icon={<EditOutlined />}
            />
          </Tooltip>

          <Tooltip title="Hapus hadiah">
            <Button
              danger
              type="primary"
              onClick={() => modalDeleteData(record)}
              icon={<DeleteOutlined />}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <>
      {isAlert && (
        <Alert
          message={textAlert}
          type="success"
          banner
          closable
          afterClose={() => setIsAlert(false)}
        />
      )}

      <Card
        title={
          <Space>
            <GiftOutlined />
            <b>Master Prize / Hadiah</b>
          </Space>
        }
        extra={
          <Button type="primary" onClick={() => openModal("add")}>
            <PlusOutlined /> Tambah Hadiah
          </Button>
        }
      >
        <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
          <Col xs={24} md={8}>
            <Card size="small">
              <Statistic title="Sisa Probability" value={remainingProbability} suffix="%" />
            </Card>
          </Col>

          <Col xs={24} md={8}>
            <Card size="small">
              <Statistic title="Jumlah Data Tampil" value={data.length} />
            </Card>
          </Col>

          <Col xs={24} md={8}>
            <Card size="small">
              <Statistic title="Total Data" value={page.pagination.total || 0} />
            </Card>
          </Col>
        </Row>

        <Row
          gutter={[12, 12]}
          style={{
            marginBottom: 16,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          {/* LEFT */}
          <Space wrap>
            <Search
              placeholder="Cari nama hadiah..."
              allowClear
              enterButton={<SearchOutlined />}
              onSearch={searchData}
              style={{ width: 220 }}
            />

            <Select
              style={{ width: 180 }}
              value={filterStatus}
              onChange={(value) => setFilterStatus(value)}
              options={[
                { value: "", label: "Semua Status" },
                { value: "true", label: "Aktif" },
                { value: "false", label: "Nonaktif" },
              ]}
            />

            <Select
              style={{ width: 180 }}
              value={filterStock}
              onChange={(value) => setFilterStock(value)}
              options={[
                { value: "", label: "Semua Stock" },
                { value: "available", label: "Stock Tersedia" },
                { value: "empty", label: "Stock Habis" },
              ]}
            />
          </Space>

          {/* RIGHT */}
          <Space>
            <Tooltip title="Filter">
              <Button icon={<FilterOutlined />} onClick={getData} />
            </Tooltip>

            <Tooltip title="Reset">
              <Button icon={<ReloadOutlined />} onClick={resetFilter} />
            </Tooltip>

            <Tooltip title="Template Excel">
              <Button icon={<FileExcelOutlined />} onClick={downloadTemplate} />
            </Tooltip>

            <Tooltip title="Import Excel">
              <Upload showUploadList={false} beforeUpload={importExcel}>
                <Button icon={<UploadOutlined />} loading={importLoading} />
              </Upload>
            </Tooltip>

            <Tooltip title="Export Excel">
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={() => exportPrize(data)}
              />
            </Tooltip>
          </Space>
        </Row>

        <Table
          rowKey="prize_id"
          columns={columns}
          dataSource={data}
          loading={loading}
          pagination={page.pagination}
          onChange={handleTableChange}
          scroll={{ x: 1100 }}
        />
      </Card>

      <Modal
        title={dataModal ? "Ubah Hadiah" : "Tambah Hadiah"}
        open={isModal}
        onOk={form.submit}
        onCancel={closeModal}
        okText="Simpan"
        width={750}
      >
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 16 }}
          message={`Sisa probability tersedia: ${remainingProbability}%`}
          description={`Maksimal input probability saat ini: ${maxProbability}%`}
        />

        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Row gutter={16}>

            {/* NAMA */}
            <Col span={24}>
              <Form.Item
                name="name"
                label="Nama Hadiah"
                rules={[{ required: true, message: "Nama hadiah wajib diisi!" }]}
              >
                <Input placeholder="Contoh: Voucher Diskon 50%" />
              </Form.Item>
            </Col>

            {/* DESKRIPSI */}
            <Col span={24}>
              <Form.Item
                name="description"
                label="Deskripsi"
                rules={[{ required: true, message: "Deskripsi wajib diisi!" }]}
              >
                <Input.TextArea rows={3} placeholder="Deskripsi hadiah" />
              </Form.Item>
            </Col>

            {/* STOCK */}
            <Col xs={24} md={8}>
              <Form.Item
                name="stock"
                label="Stock"
                rules={[
                  { required: true, message: "Stock wajib diisi!" },
                  {
                    validator: (_, value) => {
                      if (value === undefined || value === null || value === "") {
                        return Promise.reject(new Error("Stock wajib diisi!"));
                      }

                      if (Number(value) < 0) {
                        return Promise.reject(new Error("Stock tidak boleh minus!"));
                      }

                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <InputNumber style={{ width: "100%" }} min={0} precision={0} />
              </Form.Item>
            </Col>

            {/* PRICE */}
            <Col xs={24} md={8}>
              <Form.Item
                name="price"
                label="Harga"
                rules={[
                  {
                    validator: (_, value) => {
                      if (value === undefined || value === null || value === "") {
                        return Promise.reject(new Error("Harga wajib diisi!"));
                      }

                      if (Number(value) < 0) {
                        return Promise.reject(new Error("Harga tidak boleh minus!"));
                      }

                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  precision={2}
                  formatter={(value) =>
                    `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                  }
                  parser={(value) => value.replace(/Rp\s?|(\.*)/g, "")}
                />
              </Form.Item>
            </Col>

            {/* PROBABILITY */}
            <Col xs={24} md={8}>
              <Form.Item
                name="probability"
                label={`Probability (%) - Max ${Number(maxProbability).toFixed(2)}%`}
                rules={[
                  { required: true, message: "Probability wajib diisi!" },
                  {
                    validator: (_, value) => {
                      const probability = Number(value || 0);

                      if (!value) {
                        return Promise.reject(
                          new Error("Probability wajib diisi!")
                        );
                      }

                      if (probability > Number(maxProbability)) {
                        return Promise.reject(
                          new Error(
                            `Probability maksimal ${Number(maxProbability).toFixed(2)}%`
                          )
                        );
                      }

                      if (probability < 0.01) {
                        return Promise.reject(
                          new Error("Probability minimal 0.01%")
                        );
                      }

                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  min={0.01}
                  max={Number(maxProbability)}
                  precision={2}
                  step={0.01}
                  stringMode
                  addonAfter="%"
                  placeholder={`0.01 - ${Number(maxProbability).toFixed(2)}`}
                />
              </Form.Item>
            </Col>

            {/* STATUS */}
            <Col xs={24} md={12}>
              <Form.Item
                name="is_active"
                label="Status"
                rules={[{ required: true, message: "Status wajib dipilih!" }]}
                initialValue="true"
              >
                <Select
                  options={[
                    { value: "true", label: "Aktif" },
                    { value: "false", label: "Nonaktif" },
                  ]}
                />
              </Form.Item>
            </Col>

            {/* IMAGE */}
            <Col xs={24} md={12}>
              <Form.Item
                name="image"
                label="Gambar Hadiah"
                valuePropName="fileList"
                getValueFromEvent={(e) => e && e.fileList}
                rules={[
                  {
                    validator: () => {
                      if (!imagePreview && !dataModal) {
                        return Promise.reject("Gambar wajib diupload!");
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Upload
                  listType="picture-card"
                  showUploadList={false}
                  onChange={uploadImage}
                  beforeUpload={() => false}
                >
                  {imagePreview ? (
                    <img
                      src={imagePreview}
                      alt="prize"
                      style={{
                        width: 100,
                        height: 100,
                        borderRadius: 12,
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    uploadButton
                  )}
                </Upload>
              </Form.Item>
            </Col>

          </Row>
        </Form>
      </Modal>

      <Modal
        title="Detail Hadiah"
        open={isDetailModal}
        onCancel={() => setIsDetailModal(false)}
        footer={[
          <Button key="close" onClick={() => setIsDetailModal(false)}>
            Tutup
          </Button>,
        ]}
        width={700}
      >
        {detailData && (
          <Card>
            <Row gutter={[16, 16]}>
              <Col xs={24} md={8}>
                <Image
                  src={detailData.image}
                  width="100%"
                  style={{ borderRadius: 12 }}
                />
              </Col>

              <Col xs={24} md={16}>
                <h2>{detailData.name}</h2>
                <p>{detailData.description || "-"}</p>

                <Space direction="vertical">
                  <Tag color="green">Stock: {detailData.stock}</Tag>
                  <Tag color="blue">Probability: {detailData.probability}%</Tag>
                  <Tag color="purple">
                    Harga: {Number(detailData.price || 0).toLocaleString("id-ID")}
                  </Tag>
                  <Tag
                    color={
                      detailData.is_active === true ||
                        detailData.is_active === "true"
                        ? "green"
                        : "red"
                    }
                  >
                    {detailData.is_active === true || detailData.is_active === "true"
                      ? "Aktif"
                      : "Nonaktif"}
                  </Tag>
                </Space>
              </Col>
            </Row>
          </Card>
        )}
      </Modal>
    </>
  );
}

export default ListPrize;